import { Rectangle } from './Rectangle';
/**
 * A visual element that renders a rectangular process flowchart symbol.
 */
export class Process extends Rectangle {
}
